import { Breadcrumbs, Link as MuiLink } from '@mui/material';
import { Link } from 'react-router-dom';
import VisibilityIcon from '@mui/icons-material/Visibility';
import TableViewIcon from '@mui/icons-material/TableView';
import SpeedIcon from '@mui/icons-material/Speed';
import DirectionsBusIcon from '@mui/icons-material/DirectionsBus';
import ListAltIcon from '@mui/icons-material/ListAlt';
import { Role } from '../../@types/auth';
import { useAuth } from '../../hooks';
import EditRoadIcon from '@mui/icons-material/EditRoad';

type NavbarProps = {
    onBeforeNavigate?: (event: React.MouseEvent<HTMLAnchorElement>, to: string) => void;
    titleElement?: React.ReactElement;
};

const Navbar = ({ onBeforeNavigate, titleElement }: NavbarProps) => {
    const { user } = useAuth();

    return (
        <>
            <Breadcrumbs aria-label='breadcrumb' sx={{ display: 'inline-block' }}>
                {titleElement}
            </Breadcrumbs>

            <Breadcrumbs aria-label='breadcrumb' sx={{ display: 'inline-block' }}>
                {(user?.hasRole(Role.VEZENYLO) || user?.hasRole(Role.ADMIN)) && (
                    <MuiLink
                        component={Link}
                        underline='hover'
                        sx={{ display: 'flex', alignItems: 'center', textAlign: 'right' }}
                        color='inherit'
                        to='/planner'
                        onClick={event => {
                            if (onBeforeNavigate) {
                                onBeforeNavigate(event, '/planner');
                            }
                        }}>
                        Tervező
                        <EditRoadIcon sx={{ ml: 0.5, mb: -0.125 }} fontSize={'small'} />
                    </MuiLink>
                )}
                {(user?.hasRole(Role.VEZENYLO) || user?.hasRole(Role.ADMIN)) && (
                    <MuiLink
                        component={Link}
                        underline='hover'
                        sx={{ display: 'flex', alignItems: 'center', textAlign: 'right' }}
                        color='inherit'
                        to='/plans'
                        onClick={event => {
                            if (onBeforeNavigate) {
                                onBeforeNavigate(event, '/plans');
                            }
                        }}>
                        Tervek
                        <ListAltIcon sx={{ ml: 0.5, mb: -0.125 }} fontSize={'small'} />
                    </MuiLink>
                )}
                {(user?.hasRole(Role.VEZENYLO) || user?.hasRole(Role.UGYINTEZO) || user?.hasRole(Role.ADMIN)) && (
                    <MuiLink
                        component={Link}
                        underline='hover'
                        sx={{ display: 'flex', alignItems: 'center', textAlign: 'right' }}
                        color='inherit'
                        to='/tig'
                        onClick={event => {
                            if (onBeforeNavigate) {
                                onBeforeNavigate(event, '/tig');
                            }
                        }}>
                        Teljesítési Igazolás
                        <ListAltIcon sx={{ ml: 0.5, mb: -0.125 }} fontSize={'small'} />
                    </MuiLink>
                )}
                <MuiLink
                    component={Link}
                    underline='hover'
                    sx={{ display: 'flex', alignItems: 'center', textAlign: 'right' }}
                    color='inherit'
                    to='/schedule'
                    onClick={event => {
                        if (onBeforeNavigate) {
                            onBeforeNavigate(event, '/schedule');
                        }
                    }}>
                    Menetrend
                    <VisibilityIcon sx={{ ml: 0.5, mb: -0.125 }} fontSize={'small'} />
                </MuiLink>
                {(user?.hasRole(Role.FOVEZENYLO) || user?.hasRole(Role.ADMIN)) && (
                    <MuiLink
                        component={Link}
                        underline='hover'
                        sx={{ display: 'flex', alignItems: 'center', textAlign: 'right' }}
                        color='inherit'
                        to='/speed-limits'
                        onClick={event => {
                            if (onBeforeNavigate) {
                                onBeforeNavigate(event, '/speed-limits');
                            }
                        }}>
                        Sebességlimitek
                        <SpeedIcon sx={{ ml: 0.5, mb: -0.125 }} fontSize={'small'} />
                    </MuiLink>
                )}
                {(user?.hasRole(Role.FOVEZENYLO) || user?.hasRole(Role.ADMIN)) && (
                    <MuiLink
                        component={Link}
                        underline='hover'
                        sx={{ display: 'flex', alignItems: 'center', textAlign: 'right' }}
                        color='inherit'
                        to='/matrix'
                        onClick={event => {
                            if (onBeforeNavigate) {
                                onBeforeNavigate(event, '/matrix');
                            }
                        }}>
                        Távolságmátrix
                        <TableViewIcon sx={{ ml: 0.5, mb: -0.125 }} fontSize={'small'}></TableViewIcon>
                    </MuiLink>
                )}
                {(user?.hasRole(Role.FOVEZENYLO) || user?.hasRole(Role.VEZENYLO) || user?.hasRole(Role.ADMIN)) && (
                    <MuiLink
                        component={Link}
                        underline='hover'
                        sx={{ display: 'flex', alignItems: 'center', textAlign: 'right' }}
                        color='inherit'
                        to='/line_names'
                        onClick={event => {
                            if (onBeforeNavigate) {
                                onBeforeNavigate(event, '/line_names');
                            }
                        }}>
                        Járatnevek
                        <DirectionsBusIcon sx={{ ml: 0.5, mb: -0.125 }} fontSize={'small'} />
                    </MuiLink>
                )}
            </Breadcrumbs>
        </>
    );
};

export default Navbar;
